




















































import { getRange } from '@/libs/time';
import { sleep } from '@/libs/util';
import DictMixin from '@/mixins/dict-mixin';
import AnalyzeServices from '@/services/analyze';
import { DictItemDto } from '@/services/dict';
import IndicatorServices from '@/services/indicator';
import moment from 'moment';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ChartCard from '../chart-card.vue';
import ChartLine from './chart-line.vue';
@Component({
  components: { ChartCard, ChartLine }
})
export default class DashboardTab2 extends mixins(DictMixin) {
  @Prop() condition!: string;
  @Prop() type!: string;
  @Prop() groupByField!: string;
  @Prop() whereField!: string;
  @Prop() dictCode!: string;
  @Prop() parentDictCode!: string;

  analyzeSrv = new AnalyzeServices();
  created() {
    this.getOverView();
    this.getTrend();
    this.getIndList();
  }

  confList: any[] = [];
  async getOverView() {
    if (!this.SYS_DICT[this.dictCode]) {
      await sleep(100);
      this.getOverView();
      return false;
    }
    let res = await this.analyzeSrv.getOverview({
      groupByField: this.groupByField,
      whereField: this.whereField,
      condition: this.condition,
      type: this.type,
      dictCode: this.dictCode
    });
    let categories = this.SYS_DICT[this.dictCode];
    if (this.parentDictCode) {
      categories = categories?.filter((item: DictItemDto) => item.parentItemCode == `${this.parentDictCode}_${this.condition}`);
    }
    if (categories && categories.length > 0) {
      this.confList = categories.map((v: any) => {
        let conf = res.filter((r: any) => r.dictItemCode == v.value);
        return {
          title: v.value,
          number: conf && conf.length > 0 ? conf[0].count : 0,
          percent: conf.length > 0 ? conf[0].compareValue : 0,
          dictCode: this.dictCode
        };
      });
    }
  }

  lineData: any[] = [];
  shownLineData: any[] = [];
  async getTrend() {
    if (this.treeList.length === 0) {
      await sleep(100);
      this.getTrend();
      return false;
    }
    let list: any[] = [];
    this.treeList.forEach(v => {
      if (this.checkedKeys.length === 0) {
        list.push(v);
      } else {
        if (this.checkedKeys.find(k => k === v.indCode)) {
          list.push(v);
        }
      }
    });
    let [startTime, endTime] = this.dateRange;
    let res = await this.analyzeSrv.getTrend({
      dataDate: this.date,
      startTime,
      endTime,
      type: this.type,
      whereField: this.whereField,
      condition: this.condition,
      indCodeList: list
    });
    this.items = [];
    this.indList = res.currentValue.map((v: any) => {
      this.items.push(v.indName);
      return { ...v, active: true };
    });
    this.lineData = res.rangeValue.map((v: any) => {
      if (!this.indList.find(ind => ind.indCode === v.indCode)) {
        this.items.push(v.indName);
        this.indList.push({ ...v, active: true });
      }
      return v;
    });
    this.checkedKeys = this.indList.map(ind => ind.indCode);
    this.changeShownLineData();
  }

  visible = false;
  dateRange: any = getRange('total');
  date: string = moment().format('YYYY-MM-DD');
  @Watch('date')
  @Watch('dateRange')
  onDateChange() {
    this.getTrend();
  }

  checkedKeys: string[] = [];
  treeData: any[] = [];
  treeList: any[] = [];
  indSrv = new IndicatorServices();
  async getIndList() {
    let params: any = {};
    if (this.whereField === 'ind_first_level') {
      params = { indFirstLevel_eq: this.condition };
    }
    if (this.whereField === 'ind_owner_plate') {
      params = { indOwnerPlate_eq: this.condition };
    }
    let res = await this.indSrv.getEnableList(params);
    this.treeData = [];
    this.treeList = res.map((v: any) => {
      this.treeData.push({ title: v.indName, key: v.indCode });
      return {
        indCode: v.indCode,
        indFirstLevel: v.indFirstLevel,
        indMearsureType: v.indMearsureType,
        indMearsureUnit: v.indMearsureUnit,
        indName: v.indName,
        indOwnerDept: v.indOwnerDept,
        indOwnerPlate: v.indOwnerPlate,
        indSecondLevel: v.indSecondLevel
        // indValue: 0
      };
    });
  }

  goTrend() {
    this.visible = false;
    this.getTrend();
  }

  indList: any[] = [];

  items: string[] = [];

  switchActive(k: number) {
    this.indList[k].active = !this.indList[k].active;
    this.items = [];
    this.indList.forEach(v => {
      if (v.active) this.items.push(v.indName);
    });
    this.changeShownLineData();
  }

  changeShownLineData() {
    let list: any = [];
    this.lineData.forEach((v: any) => {
      if (this.items.find(value => value === v.indName)) {
        list.push(v);
      }
    });
    this.shownLineData = list;
  }
  scrollLeft: number = 0;
  scroll(width: number) {
    let dom: any = this.$refs.indScrollDom;
    let max = dom.scrollWidth - dom.offsetWidth;
    max = max > 0 ? max : 0;
    this.scrollLeft += width;
    this.scrollLeft = this.scrollLeft > max ? max : this.scrollLeft;
    this.scrollLeft = this.scrollLeft < 0 ? 0 : this.scrollLeft;
    dom.scrollLeft = this.scrollLeft;
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
